import React, { useState, useEffect, useRef } from 'react';
import Logo from '../../Assets/images/Frame 39059 1.png';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
import apiClient from '../../Api/apiClient';
import { PHOTO_BASE_URL } from '../../Api/config';
import TopHeader from './TopHeader';
const DashBoardHeader = ({ onLogout }) => {
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const dropdownRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profileId, setProfileId] = useState('');
  const [profileData, setProfileData] = useState({
    name: '',
    photo: '',
  });
  const menuRef = useRef(null);

  const user_type = localStorage.getItem('user_type');
  // console.log('user type in DHeader:', user_type);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        let url = '/user/profile';
        if (user_type === 'affiliator') {
          url = '/affiliator/profile';
        }
        const response = await apiClient.get(url);

        setProfileId(response.data.data.id);
        setProfileData({
          name: response.data.data.full_name || '',
          photo: response.data.data.photo || '',
        });
        setProfileImage(
          response.data.data.photo
            ? `${PHOTO_BASE_URL}${response.data.data.photo}`
            : null
        );
      } catch (error) { }
    };
    fetchProfileData();
  }, []);

  const handleNavigation = (path, item) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setShowLogoutModal(false);
    localStorage.removeItem('bearer');
    localStorage.removeItem('token');
    localStorage.removeItem('user_type');
    localStorage.removeItem('premium_user');
    localStorage.removeItem('premium_user_i');
    localStorage.removeItem('user_type_i');
    onLogout();
    if (user_type === 'affiliator') {
      navigate('/affiliator-login');
    } else {
      navigate('/login');
    }
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };
  const navigate = useNavigate();

  const handleProfileClick = () => {
    // setshowProfile(!showProfile);
    navigate('/profile');
    setShowUserInfo(false);
  };

  const toggleUserInfo = () => {
    setShowUserInfo(!showUserInfo);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserInfo(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchProfileDataIfUnAuth = async () => {
    try {
      let url = '/user/profile';
      if (user_type === 'affiliator') {
        url = '/affiliator/profile';
      }
      const response = await apiClient.get(url);
      // console.log("Profile Data:",response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // console.log('Unauthorized, redirecting to login...');
        localStorage.removeItem('bearer');
        localStorage.removeItem('token');
        localStorage.removeItem('user_type');
        localStorage.removeItem('premium_user');
        localStorage.removeItem('premium_user_i');
        localStorage.removeItem('user_type_i');
        onLogout();
        if (user_type === 'affiliator') {
          navigate('/affiliator-login');
        } else {
          navigate('/login');
        }
      } else {
        console.error('Error fetching profile data:', error);
      }
    }
  };

  useEffect(() => {
    fetchProfileDataIfUnAuth();
    const interval = setInterval(() => {
      fetchProfileDataIfUnAuth();
    }, 86400000); // 24 hours in milliseconds
    return () => clearInterval(interval);
  }, [onLogout]);


  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false); // Close the menu when clicking outside
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  

  return (
    <header
      className={`w-full z-50 fixed top-0 left-0  transition-all duration-300 ease-in-out ${isScrolled ? 'bg-opacity-95 shadow-lg' : 'shadow-md'
        }`}
    >
      {/* Top Header */}
      {/* <div className="flex justify-between  items-center px-2 py-2 md:px-6 md:py-4 bg-dark-blue text-white gap-20">
        <div className="md:flex space-x-1 md:space-x-6 md:text-xs text-xs">
          <div className="flex items-center space-x-1">
            <IoIosCall className="text-gray-200 ml-2" />
            <h6>01743216756</h6>
          </div>
          <div className="flex items-center space-x-1">
            <CgMail className="text-gray-200 ml-1" />
            <h6>tenderwise.xyz@gmail.com</h6>
          </div>
        </div>
        <div className="text-gray-200 text-xs md:text-xs flex flex-col sm:flex-row md:flex-row lg:flex-row ">
          <p className="text-nowrap">Last Updated:</p>{' '}
          <p className="text-nowrap">04-02-2025, 07:16 PM</p>
        </div>
      </div> */}
      <TopHeader />
      {/* Bottom Header / Navbar */}
      <div className={`w-full ${isScrolled ? 'bg-gray-100 shadow-lg' : ''}`}>
        <nav className="flex justify-between items-center md:px-0 px-2 md:py-2 py-1 container mx-auto">
          {/* logo */}
          <a
            // onClick={() => handleNavigation('/')}
            href="/"
            className="flex items-center space-x-0 cursor-pointer"
          >
            <img src={Logo} alt="Logo" className="md:h-16 w-36 h-14 md:w-44" />
          </a>

          {/* Desktop Menu */}
          {user_type === 'affiliator' ? (
            <ul className="hidden lg:flex space-x-6 text-gray-700 font-bold">
              {['Dashboard', 'Tender Publish', 'View Request', 'Account'].map(
                (item, index) => (
                  <li key={index}>
                    <button
                      onClick={() =>
                        handleNavigation(
                          item === 'Dashboard'
                            ? '/affiliator-dashboard'
                            : item === 'View Request'
                              ? '/editMyTender'
                              : item === 'Account'
                                ? '/history'
                                : `/${item.replace(/\s/g, '').toLowerCase()}`,
                          item
                        )
                      }
                      className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
                    >
                      {item}
                    </button>
                  </li>
                )
              )}
            </ul>
          ) : (
            <ul className="hidden lg:flex space-x-6 text-gray-700 font-bold">
              {[
                'My Tender',
                'Tender Publish',
                'Pricing',
                'Contact Us',
                'About Us',
              ].map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      handleNavigation(
                        item === 'My Tender'
                          ? '/dashboard'
                          : // : item === 'Our Courses'
                          // ? '/ourcourses'
                          item === 'Pricing'
                            ? '/pricingPackages'
                            : item === 'About Us'
                              ? '/about'
                              : `/${item.replace(/\s/g, '').toLowerCase()}`,
                        item
                      )
                    }
                    className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          )}

          {/* User Info and Mobile Menu Button */}
          <div className="flex items-center gap-1 md:gap-2">
            {/* User Info */}
            <div className="relative">
              <div
                className="flex items-center gap-2 cursor-pointer"
                // onClick={toggleUserInfo}
                // onClick={() => handleNavigation('/profile')}
                onClick={() => toggleUserInfo('/TooggleUserInfo')}
              >
                <img
                  // src={UserPhoto}
                  src={
                    profileData?.photo
                      ? `${PHOTO_BASE_URL}${profileData.photo}`
                      : 'https://via.placeholder.com/50'
                  }
                  alt="User Photo"
                  className="md:h-10 h-9 w-9 md:w-10 rounded-full"
                />
                <span className="text-gray-700 text-center md:text-lg text-xs hidden md:block">
                  {profileData?.name}
                </span>
              </div>
              {showUserInfo && (
                <div
                  ref={dropdownRef}
                  className="absolute right-0 mt-1 w-40 bg-white border border-gray-200 shadow-lg rounded-md p-0 text-sm z-30"
                >
                  <div className="items-center justify-center mx-auto text-center gap-0">
                    {/* my profile */}
                    <div
                      className="cursor-pointer p-2 rounded border-b"
                      onClick={handleProfileClick}
                    >
                      {/* <FaUserCircle className="text-gray-600" /> */}
                      <span>My Profile</span>
                    </div>

                    <div className="cursor-pointer p-2 rounded border-b">
                      <button className="" onClick={handleLogoutClick}>
                        {/* <FaSignOutAlt className="text-red-600 mt-1" /> */}
                        Logout
                      </button>
                      {showLogoutModal && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 md:px-0 px-10">
                          <div className="bg-white md:p-6 p-4 rounded-lg shadow-lg">
                            <h2 className="md:text-lg text-sm font-bold md:mb-4 mb-2">
                              Are you sure you want to logout?
                            </h2>
                            <div className="flex justify-center space-x-4">
                              <button
                                onClick={confirmLogout}
                                className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
                              >
                                Yes
                              </button>
                              <button
                                onClick={cancelLogout}
                                className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-gray-700 mt-1 focus:outline-none"
              >
                {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>
            </div>
          </div>
        </nav>




        {/* Mobile Menu */}
        {isMenuOpen && (
          <div ref={menuRef} className="lg:hidden bg-blue-800 bg-opacity-90 -mt-2">
            {user_type === 'affiliator' ? (
              <ul className="flex flex-col space-y-4 text-gray-300 px-4 pb-4 pt-4">
                {['Dashboard', 'Tender Publish', 'View Request', 'Account'].map(
                  (item, index) => (
                    <li key={index}>
                      <button
                        onClick={() =>
                          handleNavigation(
                            item === 'Dashboard'
                              ? '/affiliator-dashboard'
                              : item === 'View Request'
                                ? '/editMyTender'
                                : item === 'Account'
                                  ? '/history'
                                  : `/${item.replace(/\s/g, '').toLowerCase()}`
                          )
                        }
                        className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
                      >
                        {item}
                      </button>
                    </li>
                  )
                )}
              </ul>
            ) : (
              <ul className="flex flex-col space-y-4 text-gray-300 px-4 pb-4 pt-4">
                {[
                  'MyTender',
                  'Pricing',
                  'Tender Publish',
                  'About Us',
                  'Contact Us',
                  // 'Our Courses',
                ].map((item, index) => (
                  <li key={index}>
                    <button
                      onClick={() =>
                        handleNavigation(
                          item === 'MyTender'
                            ? '/dashboard'
                            : item === 'About Us'
                              ? '/about'
                              : item === 'Pricing'
                                ? '/pricingPackages'
                                : `/${item.replace(/\s/g, '').toLowerCase()}`
                        )
                      }
                      className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </header >
  );
};

export default DashBoardHeader;








// <nav className="flex justify-between items-center md:px-0 px-2 md:py-2 py-1 container mx-auto">
// {/* logo */}
// <a
//   href="/"
//   className="flex items-center space-x-0 cursor-pointer"
// >
//   <img src={Logo} alt="Logo" className="md:h-16 w-36 h-14 md:w-44" />
// </a>

// {/* Desktop Menu */}
// {user_type === 'affiliator' ? (
//   <ul className="hidden lg:flex space-x-6 text-gray-700 font-bold">
//     {['Dashboard', 'Tender Publish', 'View Request', 'Account'].map(
//       (item, index) => (
//         <li key={index}>
//           <button
//             onClick={() =>
//               handleNavigation(
//                 item === 'Dashboard'
//                   ? '/affiliator-dashboard'
//                   : item === 'View Request'
//                     ? '/editMyTender'
//                     : item === 'Account'
//                       ? '/history'
//                       : `/${item.replace(/\s/g, '').toLowerCase()}`,
//                 item
//               )
//             }
//             className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
//           >
//             {item}
//           </button>
//         </li>
//       )
//     )}
//   </ul>
// ) : (
//   <ul className="hidden lg:flex space-x-6 text-gray-700 font-bold">
//     {[
//       'My Tender',
//       'Tender Publish',
//       'Pricing',
//       'Contact Us',
//       'About Us',
//     ].map((item, index) => (
//       <li key={index}>
//         <button
//           onClick={() =>
//             handleNavigation(
//               item === 'My Tender'
//                 ? '/dashboard'
//                 : item === 'Pricing'
//                   ? '/pricingPackages'
//                   : item === 'About Us'
//                     ? '/about'
//                     : `/${item.replace(/\s/g, '').toLowerCase()}`,
//               item
//             )
//           }
//           className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
//         >
//           {item}
//         </button>
//       </li>
//     ))}
//   </ul>
// )}

// {/* User Info and Mobile Menu Button */}
// <div className="flex items-center gap-1 md:gap-2">
//   {/* User Info */}
//   <div className="relative">
//     <div
//       className="flex items-center gap-2 cursor-pointer"
//       onClick={() => toggleUserInfo('/TooggleUserInfo')}
//     >
//       <img
//         src={
//           profileData?.photo
//             ? `${PHOTO_BASE_URL}${profileData.photo}`
//             : 'https://via.placeholder.com/50'
//         }
//         alt="User Photo"
//         className="md:h-10 h-9 w-9 md:w-10 rounded-full"
//       />
//       <span className="text-gray-700 text-center md:text-lg text-xs hidden md:block">
//         {profileData?.name}
//       </span>
//     </div>
//     {showUserInfo && (
//       <div
//         ref={dropdownRef}
//         className="absolute right-0 mt-1 w-40 bg-white border border-gray-200 shadow-lg rounded-md p-0 text-sm z-30 "
//       >
//         <div className="items-center justify-center mx-auto text-center gap-0">
//           {/* my profile */}
//           <div
//             className="cursor-pointer p-2 rounded border-b"
//             onClick={handleProfileClick}
//           >
//             <span>My Profile</span>
//           </div>

//           <div className="cursor-pointer p-2 rounded border-b">
//             <button className="" onClick={handleLogoutClick}>
//               Logout
//             </button>
//             {showLogoutModal && (
//               <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50  md:px-0 px-10">
//                 <div className="bg-white md:p-6 p-4 rounded-lg shadow-lg">
//                   <h2 className="md:text-lg text-sm font-bold md:mb-4 mb-2">
//                     Are you sure you want to logout?
//                   </h2>
//                   <div className="flex justify-center space-x-4">
//                     <button
//                       onClick={confirmLogout}
//                       className="bg-red-500 text-white py-2  px-6 rounded-lg hover:bg-red-600"
//                     >
//                       Yes
//                     </button>
//                     <button
//                       onClick={cancelLogout}
//                       className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     )}
//   </div>

//   {/* Mobile Menu Button */}
//   <div className="md:hidden">
//     <button
//       onClick={toggleMenu}
//       className="text-gray-700 focus:outline-none"
//     >
//       {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//     </button>
//   </div>
// </div>
// </nav>

